const shared = require('@fasstech/flexiget/dist/tailwind.config.js');
const tailwindColors = require('../tailwind.config.js').colors;

const colors = { ...shared.theme.extend.colors, ...tailwindColors };

module.exports = colors;
